import theme from "./theme";
var focus = function focus(props) {
  return theme(props).focus;
};
export var focusOutlineColor = function focusOutlineColor(props) {
  return focus(props).outlineColor;
};
export var focusOutlineStyle = function focusOutlineStyle(props) {
  return focus(props).outlineStyle;
};
export var focusOutlineWidth = function focusOutlineWidth(props) {
  return focus(props).outlineWidth;
};
export var focusOutlineOffset = function focusOutlineOffset(props) {
  return focus(props).outlineOffset;
};